import { useCallback, useMemo } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';
import { caSmbArticle, caSmbButton, caSmbQuestion, type ISmbTrackingUser } from 'shared/utils/tracking';

export type TUseSmbTrackingResult = {
  trackPlaceAdClick: (bannerName: string) => void;
  trackArticleClick: (articleName: string, articleLink: string, categoryName?: string) => void;
  trackQuestion: (question: string) => void;
};

export const useSmbTracking = (): TUseSmbTrackingResult => {
  const { custom } = useApplicationContext();
  const user = useMemo<ISmbTrackingUser>(
    () => ({
      userId: custom.userId ?? 0,
      isAuthorized: custom.isAuthorized ?? false,
    }),
    [custom.isAuthorized, custom.userId],
  );

  const trackPlaceAdClick = useCallback(
    (bannerName: string): void => {
      caSmbButton(user, { bannerName });
    },
    [user],
  );

  const trackArticleClick = useCallback(
    (articleName: string, articleLink: string, categoryName?: string): void => {
      caSmbArticle(user, {
        article: articleName,
        articleLink,
        categoryName,
      });
    },
    [user],
  );

  const trackQuestion = useCallback(
    (question: string): void => {
      caSmbQuestion(user, { question });
    },
    [user],
  );

  return { trackPlaceAdClick, trackArticleClick, trackQuestion };
};
